import React, { useContext, useState } from 'react';
import styles from './Estoque.module.css';
import FooterOpcoes from '../../cliente/components/FooterOpcoes';
import { ProdutosContext } from '../../../shared/contexts/ProdutosContext';
import HeaderPageEquipe from '../components/HeaderPageEquipe';
import { FiSearch, FiBox } from 'react-icons/fi';
import CardItemEstoque from '../../../shared/components/CardItemEstoque';

const FILTROS = ['Todos', 'EM FALTA', 'ACABANDO', 'ÓTIMO', 'ILIMITADO'];

const Estoque = () => {
  const { produtos, loading } = useContext(ProdutosContext);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('Todos');
  const nomeEstabelecimento = localStorage.getItem('nomeEstabelecimento');

  // quantidade null = sem controle de estoque definido pro item = ilimitado
  // (nunca "em falta"/"acabando", nunca bloqueia pedido).
  const getStatus = (produto) => {
    if (produto.quantidade === null || produto.quantidade === undefined) return 'ILIMITADO';

    const quantidade = Number(produto.quantidade);
    const quantidadeMinima = Number(produto.quantidade_minima);

    if (quantidade === 0) return 'EM FALTA';
    if (quantidade < quantidadeMinima) return 'ACABANDO';
    return 'ÓTIMO';
  };

  const getStatusClass = (produto) => {
    if (produto.quantidade === null || produto.quantidade === undefined) return 'unlimited';

    const quantidade = Number(produto.quantidade);
    const quantidadeMinima = Number(produto.quantidade_minima);

    if (quantidade === 0) return 'missing';
    if (quantidade < quantidadeMinima) return 'low';
    return 'ok';
  };

  const filteredProdutos = loading ? [] : produtos.filter((produto) => {
    const matchesSearch =
      produto.nome_item.toLowerCase().includes(search.toLowerCase()) ||
      (produto.categoria && produto.categoria.toLowerCase().includes(search.toLowerCase()));

    const status = getStatus(produto);
    const matchesStatus = statusFilter === 'Todos' || status === statusFilter;

    return matchesSearch && matchesStatus;
  });

  const totalEmFalta = loading ? 0 : produtos.filter(p => getStatus(p) === 'EM FALTA').length;
  const totalAcabando = loading ? 0 : produtos.filter(p => getStatus(p) === 'ACABANDO').length;

  return (
    <div className={styles.container}>
      <HeaderPageEquipe
        nomeEstabelecimento={nomeEstabelecimento}
        nomePage="Estoque"
      />

      <div className={styles.resumoFaixa}>
        <div className={styles.resumoItem}>
          <span className={styles.resumoValor}>{loading ? '–' : produtos.length}</span>
          <span className={styles.resumoLabel}>itens</span>
        </div>
        <div className={styles.resumoDivisor} />
        <div className={styles.resumoItem}>
          <span className={`${styles.resumoValor} ${styles.resumoValorAlerta}`}>{totalEmFalta}</span>
          <span className={styles.resumoLabel}>em falta</span>
        </div>
        <div className={styles.resumoDivisor} />
        <div className={styles.resumoItem}>
          <span className={`${styles.resumoValor} ${styles.resumoValorAviso}`}>{totalAcabando}</span>
          <span className={styles.resumoLabel}>acabando</span>
        </div>
      </div>

      <div className={styles.searchContainer}>
        <div className={styles.searchBox}>
          <FiSearch size={16} className={styles.searchIcon} />
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Buscar itens..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className={styles.filterContainer}>
          {FILTROS.map((status) => (
            <button
              key={status}
              className={`${styles.filterBtn} ${statusFilter === status ? styles.activeFilter : ''}`}
              onClick={() => setStatusFilter(status)}
            >
              {status}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.stockContainer}>
        {loading ? (
          <p className={styles.loadingTexto}>Carregando estoque...</p>
        ) : filteredProdutos.length === 0 ? (
          <div className={styles.vazio}>
            <FiBox size={32} className={styles.vazioIcone} />
            <p>Nenhum item encontrado.</p>
          </div>
        ) : (
          filteredProdutos.map((produto) => (
            <CardItemEstoque
              key={produto.id_item}
              produto={produto}
              getStatus={getStatus}
              getStatusClass={getStatusClass}
            />
          ))
        )}
      </div>

      <FooterOpcoes typeView="equipe" />
    </div>
  );
};

export default Estoque;
